import { call, put } from 'redux-saga/effects';
import { photoCaptureDataFailureAction, photoCaptureIntelligentEstimatorSummarySubmitSuccessAction } from '../actions';
import { IntelligentPhotoCaptureEstimatorSummarySubmitService } from '../services';
import { getErrorMessagesBasedOnStatusCode, getHtmlUrlString } from '../utilities';
/**
 * Saga to handle estimator summary submit request
 * @param action - The action containing company code and context id
 * @yields Effects for Redux-Saga
 */
export function* intelligentPhotoCaptureEstimatorSummarySubmitSaga(action) {
    try {
        const { companyCode, contextId } = action.payload;
        const estimatorSummarySubmitService = new IntelligentPhotoCaptureEstimatorSummarySubmitService();
        const response = yield call({
            context: estimatorSummarySubmitService,
            fn: estimatorSummarySubmitService.submitEstimatorSummary
        }, companyCode, contextId);
        if (response.url && response.url.trim() !== '') {
            window.location.href = getHtmlUrlString(response.url);
        }
        else {
            yield put(photoCaptureIntelligentEstimatorSummarySubmitSuccessAction(response));
        }
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureDataFailureAction(errorMessage));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureEstimatorSummarySubmitSaga.js.map